import { Component, OnInit,OnDestroy } from '@angular/core';
import {DialogModel} from "@shared/models/dialog.model";
import {DialogService} from "@shared/services/dialog-service";
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import { MatDialogRef } from "@angular/material/dialog";
import {PlatformCommand} from "@shared/commands/command-base";
@Component({
    standalone: false,
    selector: 'particle-action-button-dialog',
  templateUrl: './action-button-dialog.component.html',
  styleUrls: ['./action-button-dialog.component.scss']
})
export class ActionButtonDialogComponent implements OnInit ,IDialogView, OnDestroy {
  data: DialogModel;
  command: PlatformCommand;
  constructor(public dialogRef: MatDialogRef<ActionButtonDialogComponent>) { }

  onOkClicked(): boolean {
    return true
  }
  ngOnInit() {
    //todo: need to refactor
    this.command = this.data.input.command;
    console.log("Data pacchi?",this.data);
  }
  onDownload(type:string){
    this.dialogRef.close({action: "OK",type:type});
  }
  onPrint(type: string){
    this.dialogRef.close({action: "OK",type:type});
  }
  ngOnDestroy(): void {

  }

}
